import { queryUserSync, authdeviceV1, loginByToken } from '../../requests/loader';
import { getEnableCMRExperience } from '../Utils';
import AAF from '../../AAF/AAF';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import store from '../../store';
import { fetchLoginByToken, receiveIsLoggedIn } from '../../reducers/user';
import { playFullMedia } from '../../actions/playmedia';
import { AAFPLAYER_STOP } from '../../AAFPlayer/constants';
import Device from '../../devices/device';
import Utils from '../Utils';

class UtilsCMRExperience {
    constructor() {
        this.default = 24;
        this.isCMRExperienceInterval = null;
        this.intervalTime = null;
    
        this.setIntervalCMRExperience = this.setIntervalCMRExperience.bind(this);
    }

    //* Funcion para realizar el intervalo a la API queryUserSync
    setIntervalCMRExperience(history) {
        const { authdeviceCRM_interval } = getEnableCMRExperience();
        console.log('[authdeviceCRM_interval]:: ', authdeviceCRM_interval, history);
        const { timer_hour } = authdeviceCRM_interval;
        console.log('[timer_hour]:: ', timer_hour);
        // const timeout = parseInt(timer_hour, 10) * 60 * 60 * 1000;  // Convertir a milisegundos  a 24 horas
        const timeout = parseInt(timer_hour, 10) * 1000;  // Convertir a milisegundos 30 segundos
        console.log('[timeout]:: ', timeout);
        let hours = null;
    
        if (!this.intervalTime) {
            try {
                hours = timer_hour;
            } catch (e) {
                hours = this.default;
            }
        
            //* Se manda a llamar a la API cada 24 horas
            this.intervalTime = hours * 60 * 60 * 1000;
            //* Se manda a llamar a la API cada 30 segundos
            // this.intervalTime = hours * 1000;
        }
    
        if (this.isCMRExperienceInterval) {
            clearInterval(this.isCMRExperienceInterval);
            this.isCMRExperienceInterval = null;
        }
    
        this.isCMRExperienceInterval = setInterval(async () => {
            try {
                const result = await authdeviceV1();
                if (result && result.data) {
                    console.log("[CRM Experience interval] - success", result.data);
                } else {
                    throw new Error(result);
                }
            } catch (err) {
                console.error("[CRM Experience interval] - failed", err);
                this.closeSession();
            }
        }, this.intervalTime);
        // return timer_hour;
    }

    closeSession() {
        // Get storage items
        let ui=DeviceStorage.getItem('__UUID__');
        const hadLoginSuccess = DeviceStorage.getItem('hadLoginSuccess');

        // Stop player
        const isPlaying = store.getState().player.playerstate === 'PLAYING';
        isPlaying && this.quitPlayer();
        DeviceStorage.clear();

        // Get information from Android
        const platform = Device.getDevice().getPlatform();
        const isAndroid = platform === 'android';
        try {
            if (isAndroid && window.AndroidPlayerInterface) {
                window.AndroidPlayerInterface.getUserInformation();
            }
        } catch (error) {
            console.log('[ERROR]-error on getUserInformation', error);
        }

        // Set storage items
        DeviceStorage.setItem('__UUID__', ui);
        DeviceStorage.setItem('IsLogOut', true);
        if (hadLoginSuccess === '1') DeviceStorage.setItem('hadLoginSuccess', '1');
        Utils.cleanCustomAttribute();

        // Restart application
        window.location.href='/';
    }

    quitPlayer() {
        const props = {
            ispip: false,
            islive: false,
            ispreview: false,
            playerstate: AAFPLAYER_STOP,
            event: null,
            videoid: null,
        }
        try {
            store.dispatch(playFullMedia(props));
        } catch (err) {
            console.error("Error in quitPlayer", err);
        }
    }
}

const instanceUtilsIsCMRExperience = new UtilsCMRExperience();

export default instanceUtilsIsCMRExperience;



// WEBPACK FOOTER //
// ./src/utils/userCMR/isCMRExperience.js